import type { CSSObject } from "type/tss";
import { Theme } from "@mui/material/styles";

export const styles = (theme: Theme) => {
	return ({
		radioLabel: {
			"& .MuiFormControlLabel-label": {
				fontSize: 16,
				color: theme.palette.custom.textPrimary,
			},
		},
		// "Time Per Photo" is disclosed by the toggle above it, so it sits indented beneath it.
		indented: {
			paddingLeft: theme.spacing(4),
		},
	} satisfies Record<string, CSSObject>);
};
